import UserRoleList from "../../slices/settings/user_role/UserRoleList"
import UserRoleDetails from "../../slices/settings/user_role/UserRoleDetails"
import ModuleList from "../../slices/settings/module/ModuleList"
import ModuleDetails from "../../slices/settings/module/ModuleDetails"
import ActionList from "../../slices/settings/action/ActionList"
import ActionDetails from "../../slices/settings/action/ActionDetails"
import MasterAction from "../../slices/settings/permisssion/MasterAction"
import GetPermission from "../../slices/settings/permisssion/GetPermission"
import GetCompanyPermission from "../../slices/settings/company_permission/GetCompanyPermission"

const settingsReducer = {
    userRoleList: UserRoleList,
    userRoleDetails: UserRoleDetails,
    moduleList: ModuleList,
    moduleDetails: ModuleDetails,
    actionList: ActionList,
    actionDetails: ActionDetails,
    masterAction: MasterAction,
    getPermission: GetPermission,
    getCompanyPermission: GetCompanyPermission,
};

export default settingsReducer;